// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPersonHeart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.834 6.16a5.924 5.924 0 0 1 .72 6.552c-.81 1.56-3.19 4.484-5.668 6.627-.7-2.8-2.623-4.8-4.89-4.8-2.266 0-4.203 2.016-4.888 4.8-2.48-2.143-4.859-5.067-5.668-6.627a5.933 5.933 0 0 1 10.533-5.465l.027.051.028-.051a5.935 5.935 0 0 1 9.806-1.087zM16.893 19.34c-1.752 1.511-3.552 2.636-4.893 2.615-1.34-.02-3.137-1.104-4.889-2.616"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.258 9.197a2.468 2.468 0 1 1 3.491 3.491 2.468 2.468 0 0 1-3.49-3.49z"
    />
  </svg>
);
export default SvgPersonHeart;
